import script from "./ConectFbFriends.vue?vue&type=script&setup=true&lang=js"
export * from "./ConectFbFriends.vue?vue&type=script&setup=true&lang=js"

import "./ConectFbFriends.vue?vue&type=style&index=0&id=726c37c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726c37c4"]])

export default __exports__